export default {"src":"/_next/static/media/signout.e1151855.svg","height":12,"width":17,"blurWidth":0,"blurHeight":0};